<template>
  <ol class="person-facts pl-2 mb-0">
    <li v-for="(fact, index) in facts" :key="index" class="mb-1">
      {{ fact }}
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    facts: { type: Array, required: true },
  },
}
</script>

<style lang="scss" scoped>
.person-facts li {
  line-height: 1.5;
}
</style>
